<template>
    <div class="report-result-button-unlock">
        <button @click="clickPay" class="report-rbul-button" v-bind:class="'report-rbul-button-'+buttonType">
            <!-- 加载状态 -->
            <span v-if="buttonLocked" class="report-rbul-button-span">
                <div class="lds-default report-rbul-button-loading"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                <span class="report-rbul-button-span-loading">报告解锁生成中</span>
            </span>
            <!-- 正常状态:付费解锁 -->
            <span v-else-if="!freeBtn && !vipBtn" class="report-rbul-button-span">
                <i class="iconfont icon-key"></i>{{reportData.price}}元{{buttonText}}
            </span>
            <!-- 正常状态:免费解锁 -->
            <span v-else-if="vipBtn" class="report-rbul-button-span">
                <i class="iconfont icon-key"></i>特权免费解锁
            </span>
            <!-- 正常状态:免费解锁 -->
            <span v-else-if="freeBtn" class="report-rbul-button-span">
                <i class="iconfont icon-key"></i>免费解锁
            </span>
        </button>
    </div>
</template>

<script>
import { CONFIG } from '../../modules/config'
export default {
    name: 'ReportButton',
    props: {
        buttonType: {
            type: String,
            default() {
                return ''
            }
        },
        buttonText: {
            type: String,
            default() {
                return '解锁'
            }
        },
        reportData: {
            type: Object,
            default() {
                return {}
            }
        },
        clickFunc: {
            type: Function,
            default() {
                return function(){}
            }
        },
        freeBtn: {
            type: Boolean,
            default() {
                return false
            }
        },
        vipBtn: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data() {
        return {
            buttonLocked: false
        }
    },
    methods: {
        clickPay() {
            if(this.buttonLocked) { return; }
            this.buttonLocked = true;
            console.log('reportbutton-----clickpay', this.buttonLocked, CONFIG);
            var me = this;
            if(this.clickFunc && typeof(this.clickFunc) == 'function') {
                this.clickFunc({
                    free: this.freeBtn,
                    data: this.reportData,
                    cb: function() {
                        me.buttonLocked = false;
                    }
                });
                setTimeout(() => {
                    me.buttonLocked = false;
                }, 5000);
            }
        }
    }
}
</script>